import { ArticleHeading4, UIText1 } from '@cian/ui-kit';
import cn from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';

interface IKeyValTableProps {
  title?: string | null;
  className?: string;
  table: Array<{ title: React.ReactElement<any> | number | string; value: React.ReactElement<any> | number | string }>;
}

export const KeyValTable: React.FC<IKeyValTableProps> = ({ title, table, className }) => {
  return (
    <div className={cn(styles['container'], className)}>
      {title && <ArticleHeading4 as="P">{title}</ArticleHeading4>}

      <div className={styles['wrapper']}>
        {table.map(({ title, value }, i) => (
          <React.Fragment key={i}>
            <UIText1 color="gray60_100">{title}</UIText1>
            <UIText1>{value}</UIText1>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
